export default "__VITE_ASSET__BWDg4lBu__"